export default "__VITE_ASSET__BEJPvJc5__"